import Swiper, { Autoplay, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'


Swiper.use([Autoplay, Pagination])

const testimonialsHomepage = new Swiper('.testimonials-caroussel', {
  autoplay: {
    enabled: true,
    delay: 5000,
  },
  
  loop: true,
  spaceBetween: 20,
  slidesPerView: 1,

  pagination: {
    enabled: true,
    clickable: true,
    el: '.testimonials-caroussel__pagination',
  },

  breakpoints: {
    1024: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
  },
})

testimonialsHomepage


// WEBPACK FOOTER //
// ./scripts/components/testimonialsHomepage.js